import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 18a1.74 1.74 0 0 1-.777-.184 2.1 2.1 0 0 1-.67-.523L.509 7.726a2.1 2.1 0 0 1-.375-.636A2 2 0 0 1 0 6.368Q0 6.17.054 6q.053-.17.107-.368l1.635-4.358a1.96 1.96 0 0 1 .71-.92A1.83 1.83 0 0 1 3.593 0h12.816q.59 0 1.085.354.496.353.71.92l1.636 4.358q.054.198.107.368.054.17.054.368 0 .368-.134.722-.135.354-.375.636l-8.043 9.566q-.295.34-.67.524t-.778.184zM7.694 5.774h4.612l-1.77-3.736H9.464zm1.34 9.028v-6.99H3.138l5.898 6.99zm1.931 0 5.898-6.99h-5.898zm3.485-9.028h3.378l-1.394-3.736h-3.753zm-12.278 0H5.55l1.769-3.736H3.592z"
    }, null, -1)
  ]))]))
}
export default { render: render }